import React from 'react';
import { connect } from 'react-redux';

import {
    displayableCashback,
    getMerchantCardUrl,
    renderPluralConditional,
    hasCashback
} from '../../../services/partner/utils';
import SvgComponent from '../../SvgComponent';
import { STATIC_ROOT } from '../../../constants';
import LocalizedNavLink from '../../router/LocalizedNavLink';

const renderUpTo = (partner, UPTO) => (partner && partner.isMultiDiscount === true ? UPTO : '');

const mapStateToPropsResultCashback = state => ({
    REFUND: state.i18n.feature.partenaire.rembourse,
    UPTO: state.i18n.feature.partenaire.jusqua
});
const ResultCashback = connect(mapStateToPropsResultCashback)(({ partner, REFUND, UPTO }) =>
    hasCashback(partner) ? (
        <React.Fragment>
            {renderUpTo(partner, UPTO)}&nbsp;
            <span className="cb-value">
                {displayableCashback(
                    partner.mostDisplayableDiscountOnline.percent,
                    partner.mostDisplayableDiscountOnline.fixed
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.mostDisplayableDiscountOnline.fixed > 1 ||
                        partner.mostDisplayableDiscountOnline.percent > 1)
            )}
        </React.Fragment>
    ) : null
);

const ResultCodeReduction = ({ partner }) =>
    partner.couponCount > 0 && (
        <React.Fragment>
            <SvgComponent src={`${STATIC_ROOT}/code-promo.svg`} width="18" height="22" />
            {partner.couponCount}
        </React.Fragment>
    );

export const ResultComponent = ({ partner, onClick }) => (
    <li className="resultat flex-container-h flex-center-alt">
        <LocalizedNavLink
            to={getMerchantCardUrl(partner)}
            className="resultat-conteneur flex-container-h flex-center-alt"
            onClick={onClick}>
            <div>{partner.name}</div>
            <div className="resultat-valeur">
                <ResultCashback partner={partner} />
                <ResultCodeReduction partner={partner} />
            </div>
        </LocalizedNavLink>
    </li>
);



// WEBPACK FOOTER //
// ./src/components/header/search/ResultComponent.js